(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wabi-header-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wabi-header-navigation')) {
  customElements.define('wabi-header-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.groups = [...this.querySelectorAll('details')];
      this.groups.forEach(group => {
        group.addEventListener('toggle', () => {
          if (group.open) this.groups.forEach(other => { if (other !== group) other.open = false; });
        }, options);
        group.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            group.open = false;
            group.querySelector('summary').focus();
          }
          if (event.key === 'ArrowDown' && event.target === group.querySelector('summary')) {
            event.preventDefault();
            group.open = true;
            group.querySelector('a')?.focus();
          }
        }, options);
        group.addEventListener('focusout', event => {
          if (event.relatedTarget && !group.contains(event.relatedTarget)) group.open = false;
        }, options);
      });
      this.addEventListener('click', event => {
        if (event.target.closest('a')) this.close();
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
    }
    close() { this.groups.forEach(group => { group.open = false; }); }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
